<template>
  <section>
    <div role="group" class="multi-select-wrapper">
      <b-form-checkbox-group
        v-model="selectedRestrictionIds"
        class="d-flex flex-column"
        value-field="item"
        text-field="name"
        disabled-field="notEnabled"
      >
        <b-form-checkbox
          class="mb-3 multi-checkbox"
          v-for="application in this.data"
          :key="application.name"
          :value="application.id"
        >
          <section v-if="textIsForAdminSite">{{ application.code }} {{ application.name }}</section>
          <section v-else>
            A vállalkozásom részesült támogatásban a(z) {{ application.code }} {{ application.name }} pályázatban.
          </section>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </div>
  </section>
</template>

<script>
export default {
  props: { data: { type: Array, required: true }, preSelection: { type: Array } },
  data() {
    return {
      selectedRestrictionIds: [],
      textIsForAdminSite: false
    }
  },
  watch: {
    selectedRestrictionIds(value) {
      this.$emit('application-restriction-ids', value)
    }
  },
  mounted() {
    if (this.preSelection.length > 0) {
      this.selectedRestrictionIds = [...this.preSelection]
    }
  },
  created() {
    this.textIsForAdminSite = this.$route.path.includes('create-fund')
  }
}
</script>

<style lang="scss" scoped></style>
